export default "__VITE_ASSET__1bf48efe__"